export default __webpack_public_path__ + "static/media/small.9aee563f.jpg";